import cx from 'classnames'
import Styles from './Drawer.module.scss'
import { Drawer } from 'vaul'
import React, { forwardRef } from 'react'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

type Props = Omit<DialogPrimitive.DialogOverlayProps & React.RefAttributes<HTMLDivElement>, 'ref' | 'className'> & {
  /**
   * Whether the overlay should have a blur effect.
   * @default true
   */
  withBlur?: boolean
}

export const Overlay = forwardRef<HTMLDivElement, Props>(({ withBlur = true, ...props }, ref) => {
  const { isIOSNative } = useResponsiveDesign()

  return (
    <Drawer.Overlay
      className={cx(Styles.overlay, { [Styles.withoutBlur]: !withBlur, [Styles.withoutOpacity]: isIOSNative })}
      ref={ref}
      {...props}
    ></Drawer.Overlay>
  )
})
